export default "__VITE_ASSET__DNIq9aV6__"